/**
 * Die Statusfarben aus projekt/design/README.md lassen sich nicht umkehren:
 * Amber #B45309 ist auf Dunkel fast unsichtbar, Rot #DC2626 flimmert.
 * Dunkel hat deshalb eigene, aufgehellte Werte — geprüft in contrast.test.ts.
 *
 * statusOk (Hell) ist gegenüber dem Entwurf von #15803d auf #15783d abgedunkelt:
 * #15803d erreichte auf statusOkBg nur 4,46:1, knapp unter der WCAG-AA-Schwelle
 * von 4,5:1. #15783d liegt bei 4,93:1.
 */
export const PALETTE = {
    light: {
        bg: "#f3f3f1", surface: "#ffffff", surfaceRaised: "#f7f8f9", border: "#e3e5e8",
        text: "#1b1b19", muted: "#5c626b", accent: "#1d4ed8", accentText: "#ffffff",
        statusOk: "#15783d", statusOkBg: "#e7f5ec",
        statusRunning: "#1d4ed8", statusRunningBg: "#e8effb",
        statusWarn: "#8a4308", statusWarnBg: "#fbf0dc",
        statusBad: "#b91c1c", statusBadBg: "#fbe9e9",
        statusOff: "#54595f", statusOffBg: "#f0f1f3",
    },
    dark: {
        bg: "#141618", surface: "#1d2023", surfaceRaised: "#25282c", border: "#33373c",
        text: "#e9ebed", muted: "#a3aab2", accent: "#8ab0ff", accentText: "#0f1113",
        statusOk: "#5dd78b", statusOkBg: "#183424",
        statusRunning: "#8ab0ff", statusRunningBg: "#1a2740",
        statusWarn: "#f2b84b", statusWarnBg: "#3a2e12",
        statusBad: "#f98a8a", statusBadBg: "#3b1e1e",
        statusOff: "#a3aab2", statusOffBg: "#2a2d31",
    },
};
function kanal(anteil) {
    return anteil <= 0.04045 ? anteil / 12.92 : ((anteil + 0.055) / 1.055) ** 2.4;
}
function luminanz(hex) {
    const roh = hex.replace("#", "");
    const r = kanal(parseInt(roh.slice(0, 2), 16) / 255);
    const g = kanal(parseInt(roh.slice(2, 4), 16) / 255);
    const b = kanal(parseInt(roh.slice(4, 6), 16) / 255);
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}
/** Kontrastverhältnis nach WCAG 2.1. Text braucht mindestens 4,5:1. */
export function contrastRatio(vorne, hinten) {
    const a = luminanz(vorne);
    const b = luminanz(hinten);
    const hell = Math.max(a, b);
    const dunkel = Math.min(a, b);
    return (hell + 0.05) / (dunkel + 0.05);
}
//# sourceMappingURL=tokens.js.map